import React from 'react';
import classes from './caption.scss';
export default class Caption extends React.Component {
  render() {
    const {
      mainText,
      subText
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, mainText !== '' ? /*#__PURE__*/React.createElement("div", {
      className: classes.mainCaption
    }, mainText) : null, subText !== '' ? /*#__PURE__*/React.createElement("div", {
      className: classes.subCaption
    }, subText) : null);
  }
}